import React, { Component } from "react"
import cx from "classnames"
import "../../css/components/common/alert.scss"
import ErrorIcon from "assets/icons/error.svg"
import SuccessIcon from "assets/icons/success.svg"
import WarningIcon from "assets/icons/warning.svg"

const iconTypes = {
  success: SuccessIcon,
  warning: WarningIcon,
  error: ErrorIcon,
}
export default class Alert extends Component {
  render() {
    const { type = "warning", header, message } = this.props

    return (
      <div className={cx("alert-container", `-${type}`)}>
        <div>
          <img src={iconTypes[type]} alt="alert icon" />
        </div>
        <div className="alert-content">
          <h4>{header}</h4>
          <p>{message}</p>
        </div>
        {/* <button onClick={onClose} className="close-button">
                    <p className="close-icon">X</p>
                </button> */}
      </div>
    )
  }
}
